const pimConfig = {
  url: `${process.env.PIM_APP}`,
};

export default pimConfig;
